

























































































import { Vue, Component, Watch } from 'vue-property-decorator';
import qs from 'qs';
import { save } from '../api';
import SyEditor from '@/components/SyEditor.vue';
import { isWeiXin } from '@/common/ts/common';
import { Field, Cell, CellGroup, Toast, Calendar } from 'vant';
import Uploader from '../components/NewUploader.vue';
import { wxSdkInfo } from '../../../api/api';

Vue.use(Field)
  .use(Cell)
  .use(CellGroup)
  .use(Calendar);
@Component({
  components: {
    SyEditor,
    Uploader,
  },
})
export default class Save extends Vue {
  showSave = 3;
  title: string = '';
  contents: string = '';
  unionid: string | null = '';
  cover: any = [];
  video: any = [];
  homeUrl: string = '';
  imgNum: any = '0';
  pointOut = false;

  presetFiles(data: any) {
    console.log(data);
    this.imgNum = data;
  }

  wxConfig(statement: object) {
    window.wx.config({
      debug: false,
      ...statement,
      jsApiList: [
        // 所有要调用的 API 都要加到这个列表中
        'updateAppMessageShareData', // 分享到朋友
        'updateTimelineShareData', // 分享到朋友圈
        'onMenuShareAppMessage',
        'onMenuShareTimeline',
      ],
    });
  }

  // 分享图片处理
  getCoverImage(post: any) {
    if (post.image) {
      return post.image;
    } else {
      return 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    }
  }

  wxShareInfos(DetailsData: any) {
    const envName = process.env.VUE_APP_ENV_NAME;
    let url = '';
    if (envName === 'development') {
      url = 'http://172.16.18.209:8080/20231222GCYS/home';
    } else if (envName === 'TEST') {
      url = 'https://testdev.cqcb.com/2023h2/20231222GCYS/home';
    } else if (envName === 'production') {
      url =
        'https://activity.cqcb.com/shangyou_activity/2023h2/20231222GCYS/home';
    }
    wxSdkInfo({ jssdkurl: url }).then((res: any) => {
      const data = res.data;
      // console.log(DetailsData);
      const e = DetailsData;
      const messageData = {
        title: e.title, // 分享标题
        desc: e.subtitle, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.getCoverImage(e), // 分享图标
      };
      this.wxConfig(data);
      window.wx.ready(() => {
        window.wx.updateAppMessageShareData({
          ...messageData,
        });
        window.wx.updateTimelineShareData({
          ...messageData,
        });
      });
    });
  }

  async mounted() {
    if (!isWeiXin()) {
      Toast(`请在微信浏览器中打开`);
      setTimeout(() => {
        this.$router.push(`home`);
      }, 2000);
      return;
    }
    this.showSave = 1;
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    }
    const data = {
      unionid: this.unionid,
      token: window.gettoken(),
      appkey: window.appkey,
      wdid: window.udid,
    };
  }
  async getCover() {
    this.cover = (await (this.$refs
      .uploaderImg as Uploader).uploadToOss()) as string[];
  }

  async getVideo() {
    this.video = (await (this.$refs
      .uploaderVideo as Uploader).uploadToOss()) as string[];
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async submit() {
    if (!isWeiXin() || !this.unionid) {
      Toast('请在微信参与活动！');
      return;
    } else if (!this.title) {
      Toast('请输入标题！');
      return false;
    } else {
      const images: any = await (this.$refs
        .uploaderImg as Uploader).uploadToOss();
      if (images.length === 0) {
        Toast('请上传图片！');
        return false;
      }
      const data = {
        nickname: window.localStorage.getItem('nickname'),
        headImg: window.localStorage.getItem('headimgurl'),
        title: this.title,
        contents: this.contents,
        unionid: this.unionid,
        token: window.gettoken(),
        appkey: window.appkey,
        udid: window.udid,
        cover: images.join('|'),
        video: this.video.join('|'),
      };
      const res: any = await save(data);
      if (res.code === 200) {
        Toast(`${res.msg}`);
        setTimeout(() => {
          this.showSave = 2;
        }, 2000);
      } else {
        Toast(`${res.msg}`);
      }
    }
  }

  enterActLeft() {
    this.pointOut = true;
  }

  enterActRight() {
    //window.location.href = 'https://22750088-8263.hd.webportal.top/22750088/nYY54lqyu3ZjAwMyaKa0jw/load-22750088-8263.html?style=75&editQrcode=true&_source=1';
    window.location.href =
      'https://wx.900u.cn/app/index.php?i=1&c=entry&do=mobile&m=ndot_blindbox&s=index.index/index&act_id=28';
  }

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/webupload/o_1hife0osd1qp9guc2od15v1te17.png';
    // App分享
    this.$appShareInfo({
      title: '国潮养生',
      url: location.href,
      subtitle: `2023养固健“潮”养生息打卡活动`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.wxShareInfos({
        title: '国潮养生',
        subtitle: `2023养固健“潮”养生息打卡活动`,
        image: cover,
      });
    }
  }
}
